// Submits the nearest form on Cmd+Enter (Mac) or Ctrl+Enter (other platforms).
// Attach to a <form> element to enable keyboard submission from any field within it.
//
// Usage:
//   <form data-controller="hotkey-submit">
//     <textarea ...></textarea>
//     <button type="submit">Save</button>
//   </form>

import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    if (event.key === "Enter" && (event.metaKey || event.ctrlKey)) {
      event.preventDefault()
      this.element.requestSubmit()
    }
  }
}
